import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { debug } from 'util';
import { GlobalHealthSystem } from '../../../core/model/v2/healthSystem/global-health-system';
import { HospitalAffiliation } from '../../../core/model/v2/hospitalAffiliation';
import { Practitioner } from '../../../core/model/v2/practitioner/practitioner';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-hospital-affiliations',
  templateUrl: './hospital-affiliations.component.html',
  styleUrls: ['./hospital-affiliations.component.scss']
})
export class HospitalAffiliationsComponent implements OnInit {
  editAffiliationvar: boolean = false;
  @Input() practitionerId;
  @Output() loadPracticePage = new EventEmitter<any>();
  SymptomData: Practitioner = new Practitioner();
  hospitalsList: HospitalAffiliation[] = [];
  shortName: string = '';
  indexer: number;
  userAction: string = "";
  editAffiliationForm = new FormGroup({});
  affilicationCtrl = new FormControl();
  filteredAffiliations: Observable<HospitalAffiliation[]>;
  npiNumber: string = "";
  hsOrgType: number;
  hsId: number;
  patientId: number;
  isPractitioner: boolean=true;
  constructor(private _loaderService: WindowLoaderService,
    private _practiceService: PracticeService,
    private _snackBar: MatSnackBar,
    private readonly changeDetector: ChangeDetectorRef,
    private fb: FormBuilder,
    private router: Router, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.getParams();
    if (this.patientId > 0) {
      this.isPractitioner = false;
    }
    this.getHospitalsList();
    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      map(val =>
        this._filterAffilications(val)
      )
    );
    this.getPracDetailsById(this.practitionerId);
  }
  getParams() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.patientId = params["patientId"];
      },
      (error) => {
        console.error(error);
      }
    );
  }
  async getPracDetailsById(practitionerId: number) {
    let that = this;
    that._loaderService.show();
    await that._practiceService.getPractitionerDetails(practitionerId).subscribe(
      (practitionerData) => {
        that.SymptomData = practitionerData;
        that.changeDetector.detectChanges();
      },
      (error) => {
        console.error(error);
        that._loaderService.hide();
      },
      () => {
        that._loaderService.hide();
      }
    );
  }

  shortNameMethod(pname) {
    let result = "";
    if (this.SymptomData != null || this.SymptomData != undefined) {
      this.shortName = pname;
      let x = this.shortName.split(" ");
      if (x != undefined && x.length > 0) {
        let first = x[0];
        first = first.slice(0, 1);
        result = first;
        if (x.length > 1) {
          let second = x[1];
          second = second.slice(0, 1);
          result = first + second;
        }
      }

      return result;
    }
  }
  editAffiliation(i) {
    this.userAction = "E";
    this.processAffiliation(i);
  }
  processAffiliation(i) {

    this.indexer = i;
    this.editAffiliationvar = true;
    this.npiNumber = this.SymptomData.hospitalAffiliation[i].npi;
    this.affilicationCtrl.setValue(this.SymptomData ? this.SymptomData.hospitalAffiliation[i].name : "");
    this.changeDetector.detectChanges();
  }
  deleteAffiliation(i) {
    const affiliationDetails = {
      practitionerId: this.practitionerId,
      npi: this.SymptomData.hospitalAffiliation[i].npi
    };
    this._loaderService.show();
    this._practiceService
      .deletePhysicianAffiliation(affiliationDetails)
      .subscribe(
        (userData) => {
          this.getPracDetailsById(this.practitionerId);
          this._loaderService.hide();
          this.changeDetector.detectChanges();
        },
        (error) => {
          this._loaderService.show();
          console.error(error);
        }
      );

  }
  OnAffiliationSubmit(editAffiliationForm: FormGroup) {
    if (this.validateForm(this.indexer) != true) {
      return false;
    }

    if (this.editAffiliationForm != undefined) {
      if (this.affilicationCtrl.value == undefined || this.affilicationCtrl.value == "") {
        this._snackBar.open("Please select a location!", "Ok", {
          duration: 5000
        });
        return false;
      }
    }
    let i = this.indexer;
    const self = this;
    self._loaderService.show();
    self.npiNumber = this.hospitalsList.find(x => x.name === self.affilicationCtrl.value).npi;
    const affiliationDetails = {
      practitionerId: self.practitionerId,
      npi: self.npiNumber,
    };
    self._practiceService
      .updatePhysicianAffiliation(affiliationDetails)
      .subscribe(
        (userData) => {
          self.editAffiliationvar = false;
          this.getPracDetailsById(this.practitionerId);
          self.changeDetector.detectChanges();
          self._loaderService.hide();
        },
        (error) => {
          console.error(error);
          self._loaderService.hide();
        }
      );
  }
  getHospitalsList() {
    this._loaderService.show();
    this._practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (hospitalData) => {
        this.hospitalsList = hospitalData.healthSystems;
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      },
      () => {
        this._loaderService.hide();
      }
    );
  }
  _filterAffilications(value: string): HospitalAffiliation[] {
    if (value.length >= 2) {
      return this.hospitalsList.filter(option => option.name.toLowerCase().startsWith(value.toLowerCase()));
    }
  }
  validateForm(i) {
    let isSuccess: boolean = true;
    if (this.affilicationCtrl.value == undefined || this.affilicationCtrl.value == "") {
      this._snackBar.open("Please select a location!", "Ok", {
        duration: 5000
      });
      isSuccess = false;
    }

    return isSuccess;
  }
  backToLocation() {
    this.editAffiliationvar = false;
  }
  addNewAffiliation() {
    this.userAction = "N";
    this.indexer = 0;
    this.editAffiliationvar = true;
    this.affilicationCtrl.setValue("");
  }
  redirectToProfile(hs: HospitalAffiliation) {
   
    this.getHSHealthOrgDetails(hs.npi);

    

  }

  getHSHealthOrgDetails(npi: string) {
    this._loaderService.show();
    this._practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (data) => {
        this.hsOrgType = data.healthOrganizationTypeId;
        this.getHSDetails(npi);
        this._loaderService.hide();
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      },
      () => {
        this._loaderService.hide();
      }
    );
  }
  getHSDetails(npi: string) {
    this._practiceService.getHealthSystemByNPI(npi).subscribe(
      (data) => {
        this._loaderService.hide();
        this.hsId = data.id;
        if (this.hsId > 0) {
          if (this.hsOrgType == 2) {
            this.router.navigate(["/casemanager/profile/profilelocation/" + this.hsId]);
          }
          else {
            this.router.navigate(["/physician/profile/profilelocation/" + this.hsId]);
          }
          this.loadPracticePage.emit(this.hsId)
        }
      },
      (error) => {
        console.error(error);
        this._loaderService.hide();
      }
    );
  }

}
